import { useMemo } from 'react'
import { useQuery } from 'convex/react'
import { api } from '@ppwr/convex/_generated/api'
import { ScheduleType } from '@ppwr/convex/games/helpers'
import { ScheduledJob } from '@ppwr/convex/shared/validators/scheduledJobs'
import { useGameContext } from '../../screens/GameContainer/GameContext'

const flowSchedules: ScheduleType[] = [
  'botAction',
  'turnTimer',
  'roundProgression',
  'showdownReveal',
  'winnersReveal',
  'showdownDuration' //TODO: Remove after migration
]

type ActiveFlowSchedule = {
  isPlayerTimer: boolean
  isRoundProgression: boolean
  isShowdownReveal: boolean
  isWinnersReveal: boolean
  remainingMs: number
  activeSchedule: ScheduledJob
}

export const useActiveFlowSchedule = (
  gameId: ReturnType<typeof useGameContext>['gameId'],
  isPaused: boolean
): ActiveFlowSchedule | null => {
  const fn = 'useActiveFlowSchedule'
  const schedules = useQuery(api.games.queries.getGameSchedules, gameId ? { gameId } : 'skip')

  const activeSchedule = useMemo(() => {
    if (!schedules) {
      console.log(fn, 'No schedules object from query')
      return null
    }

    if (0 >= schedules.length) {
      console.log(fn, 'Empty schedules from query')
      return null
    }

    // Since scheduled are cancelled, unsure if needed but safer and quicker that passing through below
    if (isPaused) {
      console.log(fn, 'Game paused')
      return null
    }

    if (schedules.length > 1) {
      console.warn(fn, '2026-02-17 Should not see more than one schedule at a time!!')
      schedules.map((s) => {
        console.warn(fn, s.scheduleType, s.scheduleId)
      })
    }

    const validSchedule = schedules.find((s) => flowSchedules.includes(s.scheduleType) && s.status === 'pending')
    if (!validSchedule) {
      console.warn(fn, 'Did not find a valid flow schedule, unusual!')
    }

    return validSchedule || null
  }, [schedules, isPaused])

  if (!activeSchedule) return null

  // console.log(fn, activeSchedule.scheduleType)
  return {
    activeSchedule,
    isPlayerTimer: activeSchedule.scheduleType === 'botAction' || activeSchedule.scheduleType === 'turnTimer',
    isRoundProgression: activeSchedule.scheduleType === 'roundProgression',
    isShowdownReveal: activeSchedule.scheduleType === 'showdownReveal',
    isWinnersReveal: activeSchedule.scheduleType === 'winnersReveal',
    remainingMs: activeSchedule.scheduledFor - Date.now()
  }
}
